import sliceCreator from '../../index.js';
import {MACHINE_CREATION} from '../../../constants/index.js';
const _createMachineAction = sliceCreator('MACHINE_CREATION', MACHINE_CREATION, 'post');

const { asyncAction: createMachineAction, reducer, clearData: clearCreateMachineAction } = _createMachineAction;

export default reducer;

export {
    createMachineAction,
    clearCreateMachineAction
}